import { Component, Story, Knobs } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  text: {
    default: 'Loading',
    editor: 'textbox',
  },
  full: {
    default: false,
    editor: 'checkbox',
  },
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A tag-progress-indeterminate where you can change all the attributes',
  coreComponent: {
    html: `<tag-progress-indeterminate{{...knobs}}>
</tag-progress-indeterminate>`,
    js: `setTimeout(function () {
  var tagProgress = document.querySelector('tag-progress-indeterminate');
  tagProgress.style.display = 'none';
},5000);
`,
    knobs: PlaygroundKnobs,
  },
  coreComponent_v3: {
    html: `<tag3-progress-indeterminate{{...knobs}}>
</tag3-progress-indeterminate>`,
    js: `setTimeout(function () {
  var tagProgress = document.querySelector('tag3-progress-indeterminate');
  tagProgress.style.display = 'none';
},5000);
`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    setTimeout(function () {
      var tagProgress = document.querySelector('tag-progress-indeterminate');
      tagProgress.style.display = 'none';
    },5000);
    return (
      <TagProgressIndeterminate{{...knobs}} />
    )
  };`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    setTimeout(function () {
      var tagProgress = document.querySelector('tag3-progress-indeterminate');
      tagProgress.style.display = 'none';
    },5000);
    return (
      <Tag3ProgressIndeterminate{{...knobs}} />
    )
  };`,
    knobs: PlaygroundKnobs,
  },
};

export const TagProgressIndeterminateDocs: Component = {
  type: 'component',
  name: 'progress-indeterminate',
  description: 'Renders an indeterminate progress indicator',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'full',
      description: 'Whether the progress indicator overlays the whole screen',
      type: 'boolean',
    },
    {
      name: 'text',
      description: 'The text to display under the progress indicator',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [PlaygroundStory],
};
